import { Checkbox } from "@/components/ui/checkbox.tsx";

/**
 * TCPA-compliant SMS consent checkbox with legal language.
 * Reusable across onboarding and chat invite flows.
 */
export function SmsConsentCheckbox({
  checked,
  onCheckedChange,
}: {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}) {
  return (
    <div className="flex items-start gap-2">
      <Checkbox
        id="sms-consent"
        checked={checked}
        onCheckedChange={(v) => onCheckedChange(v === true)}
        className="mt-0.5"
      />
      <label
        htmlFor="sms-consent"
        className="cursor-pointer select-none text-xs flex flex-col gap-3"
      >
        <span className="text-muted-foreground">
          By checking this box, you consent to receive automated transactional and informational
          text messages from us for account verification and important updates. Message frequency
          varies. Message & data rates may apply. Reply STOP to unsubscribe.
        </span>
        <span className="text-muted-foreground/60">
          See our{" "}
          <a
            href="https://okthx.com/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            privacy policy
          </a>{" "}
          and{" "}
          <a
            href="https://okthx.com/terms-of-service"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            terms of service
          </a>
          .
        </span>
      </label>
    </div>
  );
}
